import React, { useEffect, useState } from "react";
import { Box, Typography, Card, CardContent, Button, Grid, Divider, Chip } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import api from "../api/api";
import Navbar from "../components/Navbar";


const EmployerPanel = () => {
  const [tasks, setTasks] = useState([]);
  const [applications, setApplications] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [tasksRes, appsRes] = await Promise.all([
          api.get("/tasks/my-tasks"),
          api.get("/applications/received"),
        ]);
        setTasks(tasksRes.data);
        setApplications(appsRes.data);
      } catch (err) {
        console.error("Error cargando datos:", err);
      }
    };
    fetchData();
  }, []);

  return (
    <Box sx={{ p: 4, backgroundColor: "#f8f9fa", marginTop: "40px", minHeight: "100vh" }}>
      <Typography variant="h4" sx={{ fontWeight: 600, mb: 3, color: "#2c3e50" }}>
        Panel del Empleador
      </Typography>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
        <Typography variant="h6" sx={{ color: "#34495e" }}>
          Mis tareas publicadas
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddCircleOutlineIcon />}
          sx={{
            borderRadius: "10px",
            textTransform: "none",
            background: "linear-gradient(90deg, #007bff 0%, #00b4d8 100%)",
            boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
          }}
        >
          Nueva Tarea
        </Button>
      </Box>

      <Grid container spacing={3}>
        {tasks.length > 0 ? (
          tasks.map((task) => (
            <Grid item xs={12} md={6} key={task.id}>
              <Card
                sx={{
                  borderRadius: "16px",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                  transition: "transform 0.2s ease",
                  "&:hover": { transform: "translateY(-5px)" },
                }}
              >
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 1, color: "#2c3e50" }}>
                    {task.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#555", mb: 1 }}>
                    {task.description}
                  </Typography>
                  <Divider sx={{ my: 1 }} />
                  <Typography variant="caption" sx={{ color: "gray" }}>
                    ID: {task.id}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <Typography variant="body1" sx={{ ml: 2, color: "gray" }}>
            No has publicado tareas aún.
          </Typography>
        )}
      </Grid>

      <Divider sx={{ my: 4 }} />
      <Typography variant="h6" sx={{ mb: 2, color: "#34495e" }}>
        Postulaciones recibidas
      </Typography>

      {applications.length > 0 ? (
        applications.map((app) => (
          <Card key={app.application_id} sx={{ mb: 2, borderRadius: "12px", boxShadow: "0 2px 10px rgba(0,0,0,0.05)" }}>
            <CardContent>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#2c3e50" }}>
                {app.worker_name}
              </Typography>
              <Typography variant="body2" sx={{ color: "#555" }}>
                Aplicó a: {app.task_title}
              </Typography>
              <Chip
                label={app.status || "Pendiente"}
                color={app.status === "aceptado" ? "success" : app.status === "rechazado" ? "error" : "warning"}
                size="small"
                sx={{ mt: 1 }}
              />
            </CardContent>
          </Card>
        ))
      ) : (
        <Typography variant="body1" sx={{ color: "gray" }}>
          No hay postulaciones por ahora.
        </Typography>
      )}
    </Box>
  );
};

export default EmployerPanel;
